<template>
  <v-col cols="auto" class="hide-sm-and-down">
    <v-toolbar-items class="hide-xs-and-down d-inline-flex top-menu" :key="reactivator">
      <template v-for="item in items">
        <template v-if="item.children">
          <v-hover :key="item.text">
            <v-btn
              text plain
              slot-scope="{ hover }"
              class="text-decoration-none black--text header__text px-2 no-spinner"
              :class="isHome ? 'white--text' : 'black--text'"
            >
              <strong>{{ item.text }}</strong>
              <v-list 
                dense class="nested-menu" v-if="hover || eagerMenu"
              >
                <v-hover v-for="child1 in item.children" :key="child1.id">
                  <v-list-item
                    v-if="child1"
                    slot-scope="{ hover }"
                    class="text-left px-6"
                  >
                    <v-list-item-title>
                      <router-link
                        v-if="child1.slug == 'worldwide'"
                        text
                        plain
                        class="item-menu__child1"
                        :to="{ name: 'ranking-worldwide', params: { top: 10 } }"
                      >
                        {{ child1.name }}
                      </router-link>
                      <router-link
                        v-else
                        text
                        plain
                        class="item-menu__child1"
                        :to="{ name: 'ranking-zone', params: { top: 10, zone: child1.slug, zoneName: child1.slug } }"
                      >
                        {{ child1.name }}
                      </router-link>
                    </v-list-item-title>
                    <v-list-item-action
                      class="justify-end item-menu__child1"
                      v-if="(hover || eagerMenu) && child1.countries"
                      ><icon
                        name="icon-long-arrow-right"
                        class="ml-3"
                        width="40"
                        height="8"
                      ></icon
                    ></v-list-item-action>
                    <v-container
                      class="nested-menu pt-5 pl-6"
                      :class="hover ? 'nested-menu__child2' : ''"
                      v-if="(hover || eagerMenu) && child1.countries"
                    >
                      <div class="divide-colum">
                        <div v-for="(child2, index) in child1.countries">
                          <router-link
                            :to="{
                              name: 'ranking-country',
                              params: {
                                country: child2.slug,
                                top: 10,
                                countryName: child2.slug
                              }
                            }"
                            class="text-decoration-none black--text d-block item-menu__child2"
                            v-html="child2.name"
                            >
                          </router-link>
                        </div>
                      </div>
                    </v-container>
                  </v-list-item>
                  <v-list-item v-else>
                    <v-list-item-title class="text-left">
                      {{ child1.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-hover>
              </v-list>
            </v-btn>
          </v-hover>
        </template>
        <router-link
          text
          plain
          v-else
          :to="{ name: item.route }"
          class="text-decoration-none header__text px-2 d-flex flex-column justify-center"
          :class="isHome ? 'white--text' : 'black--text'"
        >
          <strong v-if="item.text == 'show home button'" @click="reloadPage">{{ $gettext("News feed") }}</strong>
          <strong v-else>{{ item.text }}</strong>
        </router-link>
      </template>
    </v-toolbar-items>
  </v-col>
</template>

<script>
import Storage from "@/utils/storage";
import GolfCourseService from "@/services/GolfCourseService";
export default {
  name: "TopMenu",
  data() {
    return {
      reactivator: 0
    }
  },
  computed: {
    prerendering() {
      return this.$store.getters.prerendering;
    },
    isCommonRoute() {
      return this.$store.getters.isCommonRoute;
    },
    zoneAndCountry() {
      return this.$store.state.golfcourse
              .availableZoneAndCountry;
    },
    items() {
      const reactivator = this.reactivator;
      return [
        {
          text: "show home button",
          route: "newsfeed"
        },
        {
          text: this.$gettext("about"),
          route: "aboutUs"
        },
        {
          text: this.$gettext("Golf courses"),
          children: this.zoneAndCountry
        },
        {
          text: this.$gettext("Vloggers/Coaches"),
          route: "coaches"
        },
        {
          text: this.$gettext("Player Finder"),
          route: "player-finder"
        },
        {
          text: this.$gettext("Community"),
          route: "community"
        }
      ];
    },
    eagerMenu() {
      return !!(this.prerendering && this.isCommonRoute)
    },
    isHome() {
      if(this.$route.name === 'homepage') return true;
      if(this.$route.name.indexOf('ranking') !== -1) return true;
      return false;
    }
  },
  async mounted() {
    this.$store.dispatch("fetchAvailableZoneAndCountry");
  },
  methods: {
    reloadPage() {
      if (this.$route.name === "newsfeed") {
        window.location.reload();
      }
    }
  },
  watch: {
    zoneAndCountry(value) {
      if(value) {
        this.$store.state.toggle.isTopMenuLoaded = true
      }
    },
    '$route.params.country': {
      handler() {
        this.reactivator ++
      }
    }
  }
};
</script>
